import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

function LoadingScreen() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-kid-mist" data-testid="auth-loading">
      <div className="flex flex-col items-center gap-4">
        <div className="w-12 h-12 rounded-full border-4 border-kid-line border-t-kid-teal animate-spin" />
        <p className="text-kid-muted font-poppins text-sm">Loading…</p>
      </div>
    </div>
  );
}

export function ProtectedRoute({ children, adminOnly = false }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading || user === null) return <LoadingScreen />;
  if (!user) return <Navigate to={adminOnly ? "/ops/login" : "/login"} state={{ from: location }} replace />;
  if (adminOnly && !["admin", "super_admin"].includes(user.role)) {
    return <Navigate to="/app" replace />;
  }
  if (!adminOnly && ["admin", "super_admin"].includes(user.role)) {
    return <Navigate to="/ops" replace />;
  }
  return children;
}
